import CmsBlock from "@/helpers/editor/blocks/CmsBlock.js";
import CmsBlockTable from "@/helpers/editor/blocks/CmsBlockTable.js";
import CmsBlockTableRow from "@/helpers/editor/blocks/CmsBlockTableRow.js";
import CmsComponentText from "@/helpers/editor/components/CmsComponentText.js";
import CmsComponentImage from "@/helpers/editor/components/CmsComponentImage.js";
import CmsComponentGlyph from "@/helpers/editor/components/CmsComponentGlyph.js";

export default class CmsBlockTableCell extends CmsBlock {
    static typeDef = {
        name: `Cell|Cellule`,
        type: `table-cell`,
        category: `layout`,
        glyph: `fa-table-rows`,
        hidden: true
    }

    get parentClasses() {
        return [CmsBlockTableRow];
    }

    constructor(data, page) {
        super(data, page);

        this.text = new CmsComponentText(this.text);
        this.glyph = new CmsComponentGlyph(this.glyph);
        this.image = new CmsComponentImage(this.image);

        if (!data) {
            this.padding.init(5);
            this.image.active = false;
            this.glyph.active = false;
        }
    }
}
